/* GlowBiome Serum LP — interactions */

/* --- Floating cart anchor: show once the hero (FV) is scrolled past ------- */
(function () {
  var fab = document.querySelector('.cart-fab');
  var hero = document.querySelector('.scene__hero') || document.querySelector('.hero');
  if (!fab || !hero || !('IntersectionObserver' in window)) { if (fab) fab.classList.add('show'); return; }
  new IntersectionObserver(function (entries) {
    fab.classList.toggle('show', !entries[0].isIntersecting);
  }, { threshold: 0 }).observe(hero);
})();

/* --- Bundle tier selector: highlight the chosen option ------------------- */
(function () {
  document.querySelectorAll('.bundle').forEach(function (group) {
    var tiers = group.querySelectorAll('.tier');
    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        tiers.forEach(function (t) { t.classList.remove('is-active'); });
        tier.classList.add('is-active');
        var r = tier.querySelector('input[type=radio]');
        if (r) r.checked = true;
      });
    });
  });
})();

/* --- Mobile menu (hamburger) toggle ------------------------------------- */
(function () {
  var burger = document.querySelector('.nav-burger');
  var header = document.querySelector('.site-header');
  if (!burger || !header) return;
  burger.addEventListener('click', function () {
    var open = header.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  header.querySelectorAll('.nav a').forEach(function (a) {
    a.addEventListener('click', function () {
      header.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
    });
  });
})();

/* --- UGC carousel: tap to play with sound (pauses others) --------------- */
(function () {
  var cards = document.querySelectorAll('.ugc-card');
  // lazy-load posters only when the carousel approaches the viewport
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var v = e.target.querySelector('video');
        if (v && v.dataset.poster) { v.poster = v.dataset.poster; }
        io.unobserve(e.target);
      });
    }, { rootMargin: '500px 0px' });
    cards.forEach(function (c) { io.observe(c); });
  } else {
    cards.forEach(function (c) { var v = c.querySelector('video'); if (v && v.dataset.poster) v.poster = v.dataset.poster; });
  }
  cards.forEach(function (card) {
    var v = card.querySelector('video');
    if (!v) return;
    card.addEventListener('click', function () {
      if (v.paused) {
        cards.forEach(function (o) {
          var ov = o.querySelector('video');
          if (ov && ov !== v) { ov.pause(); ov.muted = true; o.classList.remove('is-playing'); }
        });
        v.muted = false;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        card.classList.add('is-playing');
      } else {
        v.pause();
      }
    });
    v.addEventListener('pause', function () { card.classList.remove('is-playing'); });
    v.addEventListener('ended', function () { card.classList.remove('is-playing'); v.currentTime = 0; });
  });
  document.querySelectorAll('.ugc__rail').forEach(function (rail) {
    var track = rail.querySelector('.ugc__track');
    function step(dir) {
      var c = track.querySelector('.ugc-card');
      var w = c ? c.offsetWidth + 16 : 280;
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;
      if (dir > 0 && x >= max - 4) { track.scrollTo({ left: 0, behavior: 'smooth' }); }   // wrap to start
      else if (dir < 0 && x <= 4) { track.scrollTo({ left: max, behavior: 'smooth' }); }   // wrap to end
      else { track.scrollBy({ left: dir * w, behavior: 'smooth' }); }
    }
    var prev = rail.querySelector('.ugc__arrow--prev'), next = rail.querySelector('.ugc__arrow--next');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  });
})();

/* --- How to Use: mobile step rail (progress bar + arrows) -------------- */
(function () {
  var rail = document.querySelector('.howto .steps');
  var ctrl = document.querySelector('.howto .steps__ctrl');
  if (!rail || !ctrl) return;
  var thumb = ctrl.querySelector('.steps__bar i');
  var prev = ctrl.querySelector('.steps__arrow--prev');
  var next = ctrl.querySelector('.steps__arrow--next');
  var cards = rail.querySelectorAll('.step');
  var n = cards.length || 1;

  function update() {
    var max = rail.scrollWidth - rail.clientWidth;
    var frac = max > 4 ? rail.scrollLeft / max : 0;
    var tw = 100 / n;                       // thumb width %
    if (thumb) { thumb.style.width = tw + '%'; thumb.style.left = (frac * (100 - tw)) + '%'; }
    if (prev) prev.disabled = rail.scrollLeft <= 4;
    if (next) next.disabled = rail.scrollLeft >= max - 4;
  }
  function step(dir) {
    var c = rail.querySelector('.step');
    var w = c ? c.offsetWidth + 12 : rail.clientWidth * 0.8;
    rail.scrollBy({ left: dir * w, behavior: 'smooth' });
  }
  if (prev) prev.addEventListener('click', function () { step(-1); });
  if (next) next.addEventListener('click', function () { step(1); });
  rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
  window.addEventListener('resize', update);
  update();
})();

/* --- Scroll reveal --------------------------------------------------------
   Auto-applies entrance animations on scroll. No markup changes required.
   Direct individual elements later with: data-reveal="up|left|right|scale|fade"
   and data-reveal-delay="120" (ms) on any element.                          */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.gsap && window.ScrollTrigger) return; // GSAP motion script handles reveals

  // Elements that reveal on their own.
  var SINGLE = [
    '.hero__head', '.hero__media', '.bb-card',
    '.problem .eyebrow', '.problem h2', '.problem .lead',
    '.solution .eyebrow', '.solution .statement',
    '.ingredients .head', '.aroma',
    '.neroli .eyebrow', '.neroli h2',
    '.texture__media', '.texture__body',
    '.howto .head', '.howto .foot',
    '.rec .head',
    '.faq .head', '.acc',
    '.bb__title'
  ].join(',');

  // Containers whose direct children reveal with a stagger.
  var GROUPS = '.cards, .ing-grid, .steps, .rec-grid, .tlist';
  var variantClass = { up: '', left: 'r-left', right: 'r-right', scale: 'r-scale', fade: 'r-fade' };

  function tag(el, delay) {
    el.classList.add('reveal');
    var v = el.getAttribute('data-reveal');
    if (v && variantClass[v]) el.classList.add(variantClass[v]);
    var d = el.getAttribute('data-reveal-delay');
    if (d) delay = parseInt(d, 10);
    if (delay) el.style.transitionDelay = delay + 'ms';
  }

  document.querySelectorAll(SINGLE).forEach(function (el) { tag(el, 0); });
  document.querySelectorAll(GROUPS).forEach(function (g) {
    Array.prototype.forEach.call(g.children, function (c, i) { tag(c, i * 90); });
  });
  // Honor explicit data-reveal added by hand anywhere.
  document.querySelectorAll('[data-reveal]').forEach(function (el) {
    if (!el.classList.contains('reveal')) tag(el, 0);
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
})();

/* --- UI interactions ------------------------------------------------------ */
(function () {
  // Quantity steppers
  document.querySelectorAll('.stepper').forEach(function (s) {
    var i = s.querySelector('input');
    var btns = s.querySelectorAll('button');
    btns[0].addEventListener('click', function () { i.value = Math.max(1, (parseInt(i.value, 10) || 1) - 1); });
    btns[1].addEventListener('click', function () { i.value = (parseInt(i.value, 10) || 1) + 1; });
  });

  // Add to cart based on the selected bundle tier (.cta in each buy box)
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { throw new Error((j && j.description) || 'Could not add to cart'); }
        return j;
      });
    });
  }
  document.querySelectorAll('.bb-right .cta').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var box = btn.closest('.bb-right');
      var checked = box && box.querySelector('.tier input:checked');
      var data = checked && checked.getAttribute('data-items');
      if (!data) return; // not wired yet
      e.preventDefault();
      var dest = btn.classList.contains('alt') ? '/checkout' : '/cart';
      var label = btn.textContent;
      btn.textContent = 'Adding…'; btn.style.pointerEvents = 'none';
      addItems(JSON.parse(data))
        .then(function () { window.location.href = dest; })
        .catch(function (err) {
          btn.textContent = label; btn.style.pointerEvents = '';
          alert('Sorry, we couldn’t add this to your cart. Please try again.\n' + (err && err.message ? err.message : ''));
        });
    });
  });
})();

/* --- Buy-box gallery: thumbnail click swaps the main image -------------- */
(function () {
  document.querySelectorAll('.bb-left').forEach(function (box) {
    var main = box.querySelector('.bb-main img');
    var thumbs = box.querySelectorAll('.bb-thumbs button');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var img = btn.querySelector('img');
        var full = btn.getAttribute('data-full') || (img && img.src);
        if (full) main.src = full;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  });
})();